import { redirect } from '../redirect';

export const onInsuranceError = (error?: Error) => {
  console.error(error?.message);
  return redirect();
};
